export const convertToNormalText = (str) => {
    return str
      .toLowerCase()
      .split("_")
      .map((word, index) =>
        index === 0
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word
      )
      .join(" ");
  };